import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { userApi } from 'src/services/user'

export const GoogleOAuthCallback = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const { mutate: saveGoogleToken } = useMutation({
    mutationFn: async (tokenData: any) => {
      return await userApi.csc.saveGoogleOAuthToken(tokenData)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] })
      navigate('/integrations', { replace: true })
    },
    onError: (error) => {
      console.error('Failed to save Google token:', error)
      navigate('/integrations?error=oauth_failed', { replace: true })
    },
  })

  useEffect(() => {
    const handleOAuthCallback = async () => {
      const code = searchParams.get('code')
      const state = searchParams.get('state')
      const error = searchParams.get('error')
      if (error) {
        console.error('OAuth error:', error)
        navigate('/integrations?error=oauth_cancelled', { replace: true })
        return
      }

      if (!code) {
        console.error('No authorization code received')
        navigate('/integrations?error=no_code', { replace: true })
        return
      }
      saveGoogleToken({
        code: code,
        state: state,
      })

      // try {
      //   // Exchange the authorization code for tokens
      //   // In a real implementation, you would typically do this exchange on the backend
      //   // For now, we'll just send the code to our backend to handle the exchange
      //   await saveGoogleToken.mutateAsync({
      //     code: code,
      //     state: state,
      //     redirect_uri: window.location.origin + '/oauth/google/callback'
      //   })
      // } catch (error) {
      //   console.error('Token exchange failed:', error)
      //   navigate('/integrations?error=token_exchange_failed', { replace: true })
      // }
    }

    handleOAuthCallback()
  }, [searchParams, navigate, saveGoogleToken])

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-primary"></div>
        <h2 className="text-xl font-semibold text-text-primary">
          Connecting your Google account...
        </h2>
        <p className="mt-2 text-text-secondary">Please wait while we complete the setup.</p>
      </div>
    </div>
  )
}
